




















































































import { Getter } from 'vuex-class';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon.vue';
import DpButton from '@/components/atoms/DpButton/index.vue';


@Component({
  name: 'MarketsTemplateMenu',
  components: {
    SvgIcon,
    DpButton,
  },
})
export default class MarketsTemplateMenu extends Vue {
  @Getter('isAuthenticated', { namespace: 'auth' })
  protected isAuthenticated!: boolean;

  @Prop({ default: false }) outOfMarket!: boolean;

  @Prop({ default: false }) allMarkets!: boolean;

  protected env: any = process.env;

  protected active: boolean = false;

  protected hidden: boolean = false;

  protected onOpen() {
    this.active = true;
  }

  protected onClose() {
    this.active = false;
  }

  protected created(): void {
    let lastScrollTop = document.body.scrollTop;
    let lastScrollElementTop = document.documentElement.scrollTop;
    window.addEventListener('scroll', () => {
      this.hidden = lastScrollTop < document.body.scrollTop
        || lastScrollElementTop < document.documentElement.scrollTop;
      lastScrollTop = document.body.scrollTop;
      lastScrollElementTop = document.documentElement.scrollTop;
    });
  }
}
